import React from "react";
import { useSession } from "../../../state/api/session/useSession";
import Pill from "../pill/Pill";

export default function AdminPill() {
  const { session } = useSession();

  if (!session?.isAdmin) {
    return null;
  }

  return (
    <div className="position-fixed" style={{ bottom: 10, right: 10, zIndex: 9999, pointerEvents: "none" }}>
      <Pill border="1px solid var(--bs-danger)" foreground="var(--bs-danger)" background="var(--bs-danger-light)" >
        ADMIN MODE
      </Pill>
    </div>
  )

}